import React from 'react';

import NodeArticleTeaser from './Teaser';
import NodeArticleFull from './Full';

const NodeArticle = ({ viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeArticleTeaser {...props} />;
    default:
      return <NodeArticleFull {...props} />;
  }
};

export default NodeArticle;
